<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <!-- Add modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-create"
      centered
      modal-class="modal-primary"
      ok-only
      :ok-title="$t('common.add')"
      @ok="addPermission"
    >
      <b-form-group :label="$t('operation.permission')">
        <b-form-input
          v-model="addForm.name"
          :placeholder="$t('operation.permission')"
        />
      </b-form-group>
    </b-modal>
    <!-- Edit modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      :ok-title="$t('common.edit')"
      @ok="editPermission()"
    >
      <b-form-group :label="$t('operation.permission')">
        <b-form-input
          v-model="editForm.name"
          :placeholder="$t('operation.permission')"
        />
      </b-form-group>
    </b-modal>
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button variant="primary" @click="showModal">
            {{ $t('common.add') }} {{ $t('operation.permission') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="m-2">
      <b-row>
        <b-col cols="12" md="12">
          <br />
        </b-col>
        <b-col cols="12" md="2"> </b-col>
        <b-col md="4">
          <b-form-group
            class="mt-25"
            :label="`${$t('common.search')} ${$t('operation.permissions')}`"
            label-for="Permission"
          >
            <b-form-input
              @keyup.enter="index()"
              v-model="filterData.name"
              :placeholder="$t('operation.permission')"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="2"
          md="2"
          class="d-flex align-items-center justify-content-start mt-75 mb-1 mb-md-0"
        >
          <b-button variant="primary" @click="index()">
            {{ $t('common.search') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-table
      :items="all_data.data"
      responsive
      :fields="tableColumns"
      primary-key="id"
      v-if="!loading"
      show-empty
      empty-text="No matching records found"
      class="position-relative"
    >
      <!-- Column: Id -->
      <template #cell(Id)="data">
        <b-link class="font-weight-bold">
          {{ data.item.id }}
        </b-link>
      </template>

      <!-- Column: Name -->
      <template #cell(Name)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.name.replace(/-/g, ' ') }}
          </span>
        </b-media>
      </template>

      <!-- Column: created_at -->
      <template #cell(Created_at)="data">
        <span class="text-nowrap" style="unicode-bidi: isolate" :style="{  direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr' }">
          {{ data.item.created_at }}
        </span>
      </template>
      <!-- Column: updated_at -->
      <template #cell(Updated_at)="data">
        <span class="text-nowrap" style="unicode-bidi: isolate" :style="{  direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr' }">
          {{ data.item.updated_at }}
        </span>
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- Dropdown -->
          <ActionsButtons
            :noDelete="true"
            editPerm="update-permission"
            @editToggle="showEditModel(data.item)"
          />
         
        </div>
      </template>
    </b-table>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.label')" />
        </div>
      </div>
    </template>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted"
            >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
          @click="index()"
        >
          <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="take"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BSpinner,
  VBModal,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ActionsButtons from '@/components/common/ActionsButtons.vue';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BSpinner,
    ActionsButtons,
  },
  data() {
    return {
      tableColumns: [
        // { key: 'Id', label: '#', sortable: true },
        { key: 'Name', label: this.$t('common.name'), sortable: true },
        {
          key: 'Created_at',
          label: this.$t('common.created-at'),
          sortable: true,
        },
        {
          key: 'Updated_at',
          label: this.$t('common.updated-at'),
          sortable: true,
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      loading: true,
      page: 1,
      take: 20,
      totalInvoices: 0,
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalRows: '',
      sortBy: 'id',
      isSortDirDesc: true,
      statusFilter: null,
      addForm: {
        name: '',
      },
      editForm: {
        name: '',
        _method: 'PUT',
      },
      editId: '',
      params: {
        form: {},
        path: '',
      },
      filterData: {
        name: '',
        order_status: '',
        order_by: '',
        order_type: '',
      },
    };
  },
  mounted() {
    // this.checkAuth().then(() => {
    this.index();
    // });
  },
  methods: {
    async index() {
      await this.getList(
        `/permission?take=${this.take}&page=${this.page}&filter[name]=${this.filterData.name}&sort=-created_at`
      );
      this.loading = false;
      this.totalRows = this.all_data.total;
    },
    showModal() {
      this.$bvModal.show('modal-create');
    },
    showEditModel(item) {
      this.editForm.name = item.name;
      this.editId = item.id;
      this.$bvModal.show('modal-edit');
    },
    addPermission() {
      (this.params.form = this.addForm),
        (this.params.path = '/permission'),
        this.$store
          .dispatch('create', this.params)
          .then(() => {
            this.loading = true;
            this.index();
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Permission Created',
                icon: 'success',
                variant: 'info',
                text: 'Permission ' + this.addForm.name + ' Added Successfully',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    editPermission() {
      (this.params.form = this.editForm),
        (this.params.path = `/permission/${this.editId}`),
        this.$store
          .dispatch('update', this.params)
          .then(() => {
            this.loading = true;
            this.index();
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Permission Updated',
                icon: 'success',
                variant: 'info',
                text:
                  'Permission ' + this.editForm.name + ' Updated Successfully',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
